import { useEffect, useRef, useState } from "react";

const useImageLoaded = () => {
  const [loaded, setLoaded] = useState(false);
  const ref: any = useRef();

  const onLoad = () => {
    setLoaded(true);
  };

  useEffect(() => {
    // eslint-disable-next-line no-undef
    let timer1: NodeJS.Timeout;
    if (ref.current && ref.current.complete) onLoad();
    else timer1 = setTimeout(() => onLoad(), 3 * 1000);
    return () => {
      if (timer1) clearTimeout(timer1);
    };
  }, [ref]);

  return [ref, loaded, onLoad];
};

export default useImageLoaded;
